import React, {useEffect} from "react"
import {Form, Select} from "antd"
import {useDispatch, useSelector} from "react-redux"
import FIOInput from "../../../components/FormItems/FIOInput";
import {getDocTypes} from "../../../store/actions/user";
import {AppStateType} from "../../../store";
import {useTranslation} from "react-i18next";
import {CustomSelect} from "../../../components/Custom/Select";
import {NsiItem} from "../../../api/types";
import {CustomInput} from "../../../components/Custom/Input";
import IssueDocInput from "../../../components/FormItems/IssueDocInput";

const { Option } = Select

const Foreign = (props: any) => {
	const dispatch = useDispatch()
	const {t} = useTranslation(['resources', 'translation'])
	/*const [docType, setDocType] = useState()*/
	const { form, userType, isNotToChange } = props
	const user = props.user ? props.user : {}
	const {docTypes} = useSelector((state: AppStateType) => state.userReducer)
	let fDocTypes: NsiItem[] = []

	if(userType == 21)//Иностранный гражданин
		fDocTypes = docTypes.filter(n => n.code == 3 || n.code == 99)
	else if (userType == 30)//Лицо без гражданства
		fDocTypes = docTypes.filter(n => n.code == 8 || n.code == 9)

	useEffect(() => {
		if (!docTypes || !docTypes.length)
			dispatch(getDocTypes())
	}, [docTypes])

	useEffect(() => {
		if(userType == 21)
			form.setFieldsValue({ docTypeCode: 3})//Национальный паспорт иностранного гражданина
		else if (userType == 30)
			form.setFieldsValue({ docTypeCode: 9})//Вид на жительство в Республике Беларусь
	}, [userType])
	//const docTypeChange = (value: number) => {setDocType(value)}

	return (
		<>
			<FIOInput/>
			<Form.Item
				className="new-block"
				label={t('DocTypeNameList')}
				name="docTypeCode"
				rules={[
					{
						required: true
					}
				]}
			>
				<CustomSelect
					//value={docType}
					//onChange={docTypeChange}
				>
					{fDocTypes &&
					fDocTypes.map((e) => {
						return (<Option key={e.id} value={e.code}>{e.name}</Option>)
					})}
				</CustomSelect>
			</Form.Item>
			<Form.Item
				hasFeedback
				label={t('AppUserNumberForeignDoc')}
				name="numberForeignDoc"
				normalize={(value) => (value ? value.trim() : value)}
				rules={[
					{
						required : true,
						message : t('validation:RequiredField')
					},
					{
						pattern  : /^(?=^.{7,14}$)[a-zA-Z0-9]+$/,
						message  : t('validation:ApplicationUserNumberForeignDocValidation')
					}
				]}
			>
				<CustomInput
					autoComplete="off"
					maxLength={50}
					placeholder=''
				/>
			</Form.Item>
			<Form.Item
				hasFeedback
				dependencies={["numberForeignDoc"]}
				label={t('ApplicationUserConfirmNumberForeignDoc')}
				name="confirmNumberForeignDoc"
				normalize={(value) => (value ? value.trim() : value)}
				rules={[
					{
						required : true,
						message : t('validation:RequiredField')
					},
					({ getFieldValue }) => ({
						validator(_, value){
							if (!value || getFieldValue("numberForeignDoc") === value)
								return Promise.resolve()
							return Promise.reject(t('validation:AppUserModelValidateNumberForeignDoc'))
						}
					})
				]}
			>
				<CustomInput
					autoComplete="off"
					maxLength={50}
					placeholder=''
				/>
			</Form.Item>
			<IssueDocInput />
		</>
	)
}

export default Foreign
